(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global['native-api'] = global['native-api'] || {})));
}(this, (function (exports) { 'use strict';

/**
 * @module native-api
 */

/* eslint-disable prefer-rest-params,no-underscore-dangle */
var nativeApi = getNativeApi();

var register = nativeApi.register;
var invoke = nativeApi.invoke;

/**
 * 获取native-api
 */
function getNativeApi() {
    if (!window.gzNativeApi) {
        window.gzNativeApi = createNativeApi();
    }
    return window.gzNativeApi;
}

function createNativeApi() {
    var callHandler = [];
    var registerHandler = [];
    var api = void 0;

    createWebViewJavascriptBridge();

    setupJavascriptBridge

    /**
     * 跟naitve建立链接
     */
    ();function setupJavascriptBridge() {
        /**
         * 当前是否在瓜子 APP 中
         * @type {boolean}
         * @private
         */
        var isApp = /guazi|ganji/i.test(window.navigator.userAgent);

        if (!isApp) {
            return;
        }

        if (window.navigator.userAgent.indexOf('Android') > -1) {
            setupAndroidJavascriptBridge(function (bridge) {
                if (!bridge._messageHandler) {
                    bridge.init(function (message, responseCallback) {
                        var data = { 'Javascript Responds': 'Wee!' };
                        responseCallback(data);
                    });
                }
            });
        } else {
            setupIosJavascriptBridge(function (bridge) {
                window.WebViewJavascriptBridge = bridge;
            });
        }
    }

    /**
     * 调用 native 方法
     * @function invoke
     * @param {string} apiName - native api 的方法名
     * @param {object} params - 传递的参数, 可为 null
     * @param {function} callback - 回调
     *
     * @example
     * // 调用 native 的确认弹框
     * NativeApi.invoke('confirm', {
     *      title: '提示',
     *      message: 'msg'
     *      yes_btn_text: '拨打电话',
     *      no_btn_text: '去“我的招聘”'
     * }, function(data){
     *    if (data.value === 1) {
     *           alert('确认')
     *    } elseif (data.value === 0) {
     *           alert('取消')
     *    }
     * })
     */
    function invoke(apiName, params, callback) {
        if (!window.WebViewJavascriptBridge) {
            callHandler.push(arguments);
        } else {
            window.WebViewJavascriptBridge.callHandler.apply(this, arguments);
        }
    }

    /**
     * 注册给 native 调用的 js 方法
     * @function register
     * @param {string} apiName - native api 的方法名
     * @param {registerCallback} callback - 回调
     *
     * @example
     * // 注册回退方法
     * NativeAPI.register('back', function (data, responseCallback) {
     *      // 返回消息给 native
     *      responseCallback('{preventDefault: true}');
     * });
     */
    function register(apiName, callback) {
        if (!window.WebViewJavascriptBridge) {
            registerHandler.push(arguments);
        } else {
            window.WebViewJavascriptBridge.registerHandler.apply(this, arguments);
        }
    }

    /**
     * 创建WebViewJavascriptBridge对象
     */
    function createWebViewJavascriptBridge() {
        Object.defineProperty(window, 'WebViewJavascriptBridge', {
            configurable: true,
            enumerable: true,
            set: function set(bridge) {
                if (bridge.callHandler) {
                    api = bridge;
                    callHandler.forEach(function (args) {
                        setTimeout(function () {
                            window.WebViewJavascriptBridge.callHandler.apply(null, args);
                        }, 0);
                    });
                    registerHandler.forEach(function (args) {
                        setTimeout(function () {
                            window.WebViewJavascriptBridge.registerHandler.apply(null, args);
                        }, 0);
                    });
                    registerHandler = [];
                    callHandler = [];
                }
            },
            get: function get() {
                return api;
            }
        });
    }

    return {
        invoke: invoke,
        register: register
    };
}

/**
 * @description 注册的 js 方法
 * @callback registerCallback
 * @param {object} data - 接受的参数
 * @param {function} responseCallback 返回给 native 的回调
 */

/**
 * 设置 ios bridge
 * @private
 * @param callback
 * @returns {*}
 */
function setupIosJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
}
function setupAndroidJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function (e, bridge) {
            callback(window.WebViewJavascriptBridge);
        }, false);
    }
}

var nativeApi_1 = {
	register: register,
	invoke: invoke
};

exports['default'] = nativeApi_1;
exports.register = register;
exports.invoke = invoke;

Object.defineProperty(exports, '__esModule', { value: true });

})));
